<template>
  <div>
    <a-form style="max-width: 500px; margin: 40px auto 0;">
      <a-form-item label="充值二维码" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <canvas id="qrccode"></canvas>
      </a-form-item>
      <a-form-item label="充值金额" :labelCol="labelCol" :wrapperCol="wrapperCol" class="stepFormText">
        <span style=" font-size: x-large; ">
          ￥
          <template v-if="dispercent<1">
            <s>{{formMoney}}</s>
            <span style="color:green;">&nbsp;&nbsp;折扣价{{(formMoney*dispercent) | numFilter}}</span>
          </template>
          <template v-else>{{formMoney}}</template>
        </span>
      </a-form-item>
      <a-divider/>
      <a-form-item :wrapperCol="{span: 19, offset: 5}">
        <a-button type="primary" @click="goBackList">回到列表</a-button>
        <a-button style="margin-left: 8px" @click="prevStep">上一步</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
var QRCode = require('qrcode')
require('vue-cookies')

import config from '@/config/defaultSettings'
export default {
  name: 'Step2',
  data() {
    return {
      formMoney: this.$parent.$parent.money,
      dispercent: this.$parent.$parent.dispercent,
      QRcodeID: this.$parent.$parent.QRcodeID,
      labelCol: { lg: { span: 5 }, sm: { span: 5 } },
      wrapperCol: { lg: { span: 19 }, sm: { span: 19 } },
      loading: false,
      websock: null,
      baseWsUrl: config.iXiaoZha.wsUrlConfig + '/adminwebsocket/tokenId/',
      wsUrl: '',
      ws: true
    }
  },
  filters: {
    numFilter(value) {
      // 截取当前数据到小数点后两位

      let realVal = parseFloat(value).toFixed(2)

      return realVal
    }
  },
  mounted() {
    QRCode.toCanvas(
      document.getElementById('qrccode'),
      location.origin + '/j/api/QRcode/QRjump?bid=' + this.QRcodeID,
      error => {
        if (error) {
          this.$message.error('二维码加载出错！')
        }
      }
    )
  },
  created() {
    this.initWebSocket()
  },
  destroyed() {
    this.ws = false
    this.websock.close() //离开路由之后断开websocket连接
  },
  methods: {
    nextStep() {
      this.ws = false
      this.websock.close() //断开websocket连接
      this.$emit('nextStep', this.formMoney, this.QRcodeID)
    },
    prevStep() {
      this.ws = false
      this.websock.close() //断开websocket连接
      this.$emit('prevStep')
    },
    goBackList() {
      this.$emit('goBackList')
    },
    initWebSocket() {
      //初始化weosocket
      this.wsUrl = this.baseWsUrl + $cookies.get('TokenID')
      this.websock = new WebSocket(this.wsUrl)
      this.websock.onmessage = this.websocketonmessage
      this.websock.onopen = this.websocketonopen
      this.websock.onerror = this.websocketonerror
      this.websock.onclose = this.websocketclose
    },
    websocketonopen() {
      // 连接建立之后执行send方法发送数据
      let actions = { ping: 'ping' }
      this.websocketsend(JSON.stringify(actions))
    },
    websocketonerror() {
      // 没连接上会一直重连，设置延迟避免请求过多
      if (this.ws) {
        const VM = this
        setTimeout(function() {
          //连接建立失败重连
          VM.initWebSocket()
        }, 1000)
      }
    },
    websocketonmessage(e) {
      const VM = this
      //数据接收
      const json = JSON.parse(e.data)
      if (event != null) {
        if (json.msgType === 1) {
          VM.nextStep()
        }
      }
    },
    websocketsend(Data) {
      //数据发送
      this.websock.send(Data)
    },
    websocketclose(e) {
      //关闭
      console.log('断开连接', e)
      if (this.ws) {
        const VM = this
        setTimeout(function() {
          //连接建立失败重连
          VM.initWebSocket()
        }, 1000)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.stepFormText {
  margin-bottom: 24px;

  .ant-form-item-label,
  .ant-form-item-control {
    line-height: 22px;
  }
}
</style>
